import React from 'react';
import t from '~t';

import { Title, Wrap } from '~ui';
import My from './my';
import Create from './create';
import Help from './help';

export default function SettingsIntegrationsDev() {
  return (
    <>
      <Title>{t.s('interest_developers')}</Title>

      <Wrap className='col-span-full'>
        <My />
        <Create />
      </Wrap>

      <Help />
    </>
  );
}
